import { createContext, useContext } from 'react';

const NavBarContext = createContext({
  closePanel: () => void 0
});
const useNavBarContext = () => {
  return useContext(NavBarContext);
};

export { NavBarContext, useNavBarContext };
//# sourceMappingURL=context.es.js.map
